import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const WITHOUT = ['Buscar proyectos cada vez.', 'Saltar entre videos.', 'Guardar capturas.', 'Buscar medidas.', 'Tener información desorganizada.', 'Volver a empezar desde cero.'];
const WITH = ['Entrar.', 'Elegir una categoría.', 'Encontrar un proyecto.', 'Consultar referencias.', 'Preparar materiales.', 'Empezar.'];
export function PainUrgencySection() {
  return <section className="relative overflow-hidden bg-[#111111]" aria-labelledby="pain-urgency-title" data-id="element-250" data-mp="3e4dfen3h3dsq">
      <div className="blueprint-grid absolute inset-0 opacity-40" aria-hidden="true" data-id="element-251" data-mp="395a7muw3yth2" />

      <div className="relative mx-auto max-w-content px-4 py-16 md:px-8 md:py-24" data-id="element-252" data-mp="3mvvsgp54hdhl">
        <div className="mx-auto max-w-3xl text-center" data-id="element-253" data-mp="3i4dsa3axbgxo">
          <h2 id="pain-urgency-title" className="title-glow reveal font-display text-2xl font-black uppercase leading-[1.08] tracking-tight text-[#F8F3EA] sm:text-4xl" data-id="element-254" data-mp="3i3m4vfrhcpih">
            Mañana podés seguir buscando.
          </h2>
          <div className="mt-6 space-y-1.5 text-[15px] leading-relaxed text-[#EFEDE8]/70 sm:text-base" data-id="element-255" data-mp="3a3r25s8uatk3">
            <p data-id="element-256" data-mp="3f2kirtjfb0oh">Podés guardar otro Reel.</p>
            <p data-id="element-257" data-mp="3f1j5diexq23l">Otro tutorial.</p>
            <p data-id="element-258" data-mp="3f0rcifcq2ih0">Otro plano.</p>
            <p data-id="element-259" data-mp="3jt0vfbff6i9s">Otra foto.</p>
            <p data-id="element-260" data-mp="3juvhwu6caifz">Otro video de YouTube.</p>
          </div>
          <p className="mt-5 text-[15px] leading-relaxed text-[#EFEDE8]/60 sm:text-base" data-id="element-261" data-mp="3osniecl1vcvs">
            Podés acumular cientos de cosas que algún día “vas a hacer”.
          </p>
          <p className="mt-4 font-display text-base font-extrabold uppercase tracking-tight text-[#D89A3D] sm:text-xl" data-id="element-262" data-mp="2r6zpw2rptepj">
            Pero acumular ideas no fabrica muebles.
          </p>
          <p className="reveal mt-8 font-display text-xl font-black uppercase leading-tight tracking-tight text-[#F8F3EA] sm:text-3xl" data-id="element-263" data-mp="311rkcxq03lg3">
            El objetivo no es que mires más carpintería.
            <span className="block text-[#FF7A00]" data-id="element-264" data-mp="gcbx2cpzqev7">Es que fabriques.</span>
          </p>
        </div>

        <div className="mx-auto mt-14 grid max-w-4xl gap-4 md:grid-cols-2" data-id="element-265" data-mp="la3pr8ygm50g">
          <div className="reveal rounded-2xl border border-[#EFEDE8]/10 bg-[#181512] p-6 sm:p-8" data-id="element-266" data-mp="2he09nqjve2wj">
            <p className="font-display text-sm font-extrabold uppercase tracking-[0.16em] text-[#EFEDE8]/55" data-id="element-267" data-mp="2cex9ajeu4kuw">
              Sin la Bóveda
            </p>
            <ul className="mt-5 space-y-2.5" data-id="element-268" data-mp="2me68prsgyron">
              {WITHOUT.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-[#EFEDE8]/65 sm:text-[15px]" data-id="element-269" data-mp="2mexsm5cpf0z3">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#E96800]" aria-hidden="true" data-id="element-270" data-mp="1ymhci0cj1j2f" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="premium-glow reveal rounded-2xl border border-[#FF7A00]/40 bg-[#181512] p-6 sm:p-8" data-id="element-271" data-mp="27hovsw4mt4zz">
            <p className="accent-glow font-display text-sm font-extrabold uppercase tracking-[0.16em] text-[#FF7A00]" data-id="element-272" data-mp="22ovt0dsq46qj">
              Con la Bóveda
            </p>
            <ul className="mt-5 space-y-2.5" data-id="element-273" data-mp="1azsocwwxcudd">
              {WITH.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-[#F8F3EA] sm:text-[15px]" data-id="element-274" data-mp="10v2i4euhn43c">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#FF7A00]" aria-hidden="true" data-id="element-275" data-mp="15liwc164utqr" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="reveal mt-12 text-center font-display text-lg font-extrabold uppercase tracking-[0.08em] text-[#D89A3D] sm:text-2xl" data-id="element-276" data-mp="vvzcotalivuu">
          Menos tiempo buscando. Más tiempo fabricando.
        </p>

        {/* Cierre emocional */}
        <div className="reveal mx-auto mt-16 max-w-2xl border-t border-[#EFEDE8]/10 pt-14 text-center" data-id="element-277" data-mp="1ojlryyt6roxj">
          <p className="font-display text-xl font-black uppercase leading-tight tracking-tight text-[#F8F3EA] sm:text-3xl" data-id="element-278" data-mp="19mkwqlbsdbub">
            Tu primer proyecto no necesita ser perfecto.
            <span className="block text-[#FF7A00]" data-id="element-279" data-mp="3udbxjxv1n4ji">Solamente necesita empezar.</span>
          </p>

          <div className="mt-8 space-y-1.5 text-[15px] leading-relaxed text-[#EFEDE8]/70 sm:text-base" data-id="element-280" data-mp="37kaj7ckc80x">
            <p data-id="element-281" data-mp="jfi45ppcl00q">Quizás querés fabricar algo para tu casa.</p>
            <p data-id="element-282" data-mp="enqav7et4g6w">Quizás querés aprender carpintería.</p>
            <p data-id="element-283" data-mp="emygu10uyqiq">Quizás ya trabajás con madera.</p>
            <p data-id="element-284" data-mp="9on6zqakcg0i">Quizás querés ampliar lo que ofrecés.</p>
          </div>

          <p className="mt-6 text-[15px] leading-relaxed text-[#EFEDE8]/85 sm:text-base" data-id="element-285" data-mp="9mj3h9gktj0r">
            No necesitás fabricar los 500 proyectos.
            <br data-id="element-286" data-mp="12ducxacck7vs" />
            Solo necesitás elegir el primero.
          </p>

          <div className="mt-8 space-y-1 font-display text-sm font-extrabold uppercase tracking-[0.14em] text-[#D89A3D] sm:text-base" data-id="element-287" data-mp="xe80320fktni">
            <p data-id="element-288" data-mp="se3it9rp7uw8">Abrí la Bóveda.</p>
            <p data-id="element-289" data-mp="sdaaw5h06zci">Buscá uno que te guste.</p>
            <p data-id="element-290" data-mp="ngab2caqystu">Prepará los materiales.</p>
            <p data-id="element-291" data-mp="nfih15wst35o">Y empezá.</p>
          </div>

          <p className="mt-8 text-[15px] leading-relaxed text-[#EFEDE8]/70 sm:text-base" data-id="element-292" data-mp="3d5cebehyztr8">
            Porque carpintería no se aprende solamente mirando.
          </p>
          <p className="mt-2 font-display text-lg font-black uppercase tracking-tight text-[#F8F3EA] sm:text-2xl" data-id="element-293" data-mp="384y4ps0q0br3">
            Se aprende fabricando.
          </p>
        </div>
      </div>
    </section>;
}